import React from "react";
import { emitUnitEvent } from "@/utils/units/unitEvents";
import { useActivateRentalJourney } from "@/hooks/useActivateRentalJourney";
import { UnitGroup } from "@/types";

let hasRunUseEffect = false;

export const useOpenEsign = (unitGroup: UnitGroup, selectedPromo: number) => {
    const activateRentalJourney = useActivateRentalJourney();
    const unitId = unitGroup.representative_unit.id;
    const facilityId = unitGroup.representative_unit.facility_id;
    React.useEffect(() => {
        const isEsign = window.location.href.includes("e-sign");
        if (!hasRunUseEffect && isEsign) {
            hasRunUseEffect = true;

            // Emit event to send Nimbus the id's
            emitUnitEvent(unitId, facilityId, selectedPromo, "rental");
            activateRentalJourney(unitId, unitGroup, selectedPromo);
        }
    }, [activateRentalJourney, facilityId, selectedPromo, unitId, unitGroup]);
};
